exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-move[data-v-5ba8ea6d], \n.list-enter-active[data-v-5ba8ea6d],\n.list-leave-active[data-v-5ba8ea6d] {\n  transition: all 0.2s ease;\n}\n.list-enter-from[data-v-5ba8ea6d],\n.list-enter[data-v-5ba8ea6d],\n.list-leave-to[data-v-5ba8ea6d] {\n  opacity: 0;\n}\n\n/* ensure leaving items are taken out of layout flow so that moving\n   animations can be calculated correctly. */\n.list-leave-active[data-v-5ba8ea6d] {\n  opacity: 0;\n  position: absolute;\n}\n", ""]);

// exports
